import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { applyTheme, getStoredTheme } from "@/lib/theme";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    applyTheme(getStoredTheme());
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        if (r.data.theme && r.data.theme !== getStoredTheme()) applyTheme(r.data.theme);
      })
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
